module.exports = __webpack_public_path__ + "static/project-dashboard-e52c98c62605d742abb5d98474baaf32.mp4";